module.exports = __webpack_public_path__ + "static/media/Icon3.97bf967b.png";